module.exports = __webpack_public_path__ + "img/cartao.9f75a8f1.svg";